
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/categories",
      function () {
        return require("private-next-pages/articles/categories/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/categories"])
      });
    }
  